import React, { useEffect, useState } from "react";
import axios from "axios";
import "./TouristPlace.css";

const TouristPlace = () => {
  const [touristPlaces, setTouristPlaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTouristPlaces = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/tourist-places`
        );
        setTouristPlaces(response.data.touristPlaces || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching tourist places:", error);
        setError("Error loading tourist places information");
        setLoading(false);
      }
    };

    fetchTouristPlaces();
  }, []);

  return (
    <div className="tourist-container">
      <div className="tourist-header">
        <h1 className="tourist-title">Tourist Attractions</h1>
        <p className="tourist-subtitle">Explore Local Points of Interest</p>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner"></div>
          Loading attractions...
        </div>
      ) : error ? (
        <div className="error-state">{error}</div>
      ) : (
        <div className="tourist-content">
          {touristPlaces.length > 0 ? (
            <div className="tourist-grid">
              {touristPlaces.map((place) => (
                <div key={place._id} className="tourist-card">
                  <div className="image-container">
                    {place.imageUrl && (
                      <img
                        src={place.imageUrl}
                        alt={place.title}
                        className="tourist-image"
                      />
                    )}
                  </div>
                  <div className="tourist-details">
                    <h3>{place.title}</h3>
                    <p className="description">{place.description}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-data">No tourist places available</div>
          )}
        </div>
      )}
    </div>
  );
};

export default TouristPlace;